import React from 'react';
import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import {
  getBrandingColor, colorTypes, getBrandingStyleOverride, styleOverrides,
} from 'src/branding';
import { faArrowDown, faArrowUp, faAngleDown } from '@fortawesome/free-solid-svg-icons';

import SearchBox from '../../components/SearchBox';
import {
  Page, Column, Row, Label, Icon,
} from '../../components/Layout';

export const GeneralStatsEntity = ({
  data,
  unit,
  primaryDescription,
  secondaryDescription,
  changeArrow,
}) => (
  <Column shrink padding="1.3em">
    <Label
      noWrap
      justify="center"
      align="center"
      size="3em"
      bold
      style={{
        color: getBrandingColor(colorTypes.statisticsGeneralStatsData),
      }}
    >
      {changeArrow && data !== 0 && (
        <Icon
          inline
          size="1rem"
          marginBottom="0.1em"
          color={
              data > 0
                ? getBrandingColor(colorTypes.good)
                : getBrandingColor(colorTypes.warn)
            }
          icon={data > 0 ? faArrowUp : faArrowDown}
        />
      )}
      {data}
      {unit && (
        <Label inline marginBottom="-8px" size="1rem" marginLeft="0.1em">
          {unit}
        </Label>
      )}
    </Label>
    {primaryDescription && (
      <Label justify="center" align="center">
        {primaryDescription}
      </Label>
    )}
    <Label justify="center" align="center" color="#b6b6b6" style={{ visibility: secondaryDescription ? 'visible' : 'hidden' }}>
      {secondaryDescription}
    </Label>

  </Column>
);

export const FilterDropdownWrapper = styled.div`
  display: flex;
  margin-right: 1em;

  @media screen and (max-width: 500px) {
    width: 100%;
    flex-wrap: wrap;
    margin-bottom: 0em;

    & > {
      width: 100%;
    }

    ${Label} {
      width: 100%;
    }
  }
`;

export const SelectedFilter = styled(Label)`
  ${getBrandingStyleOverride(styleOverrides.statisticsSelectedFilter)}
`;

export const FilterDropdown = ({
  label,
  items,
  onChange,
  selected,
  minWidthContent,
  wrapperStyle,
}) => (
  <FilterDropdownWrapper style={{ ...wrapperStyle }}>
    <Label
      color="#4a4a4a"
      font="serif"
      size="1.5em"
      name="statisticsSelectedFilter"
      style={{ alignSelf: 'center' }}
      paddingRight="0.5em"
    >
      {label}
    </Label>
    <SearchBox
      noPadding
      dropdownOnly
      rowHeight={42}
      items={items}
      closeOnSelect
      onChange={onChange}
    >
      <Row
        align="center"
        style={{ minWidth: minWidthContent }}
        padding="1em 0"
      >
        <SelectedFilter
          bold
          color="#4a4a4a"
          font="serif"
          size="1.5em"
          name="statisticsSelectedFilter"
        >
          {selected.text}
        </SelectedFilter>
        <Icon size="1.5em" marginLeft="0.5em" icon={faAngleDown} />
      </Row>
    </SearchBox>
  </FilterDropdownWrapper>
);

export const compareArrow = (value, reverse) => {
  if (!value) {
    return null;
  } else if (value > 0) {
    return (
      <Icon
        inline
        size="1rem"
        marginBottom="0.1em"
        color={
          !reverse
            ? getBrandingColor(colorTypes.good)
            : getBrandingColor(colorTypes.warn)
        }
        icon={faArrowUp}
      />
    );
  }
  return (
    <Icon
      inline
      size="1rem"
      marginBottom="0.1em"
      color={
        !reverse
          ? getBrandingColor(colorTypes.warn)
          : getBrandingColor(colorTypes.good)
      }
      icon={faArrowDown}
    />
  );
};

export const Header = ({ children, ...props }) => (
  <Label
    as="h2"
    color="#4a4a4a"
    font="serif"
    size="2em"
    {...props}
    style={{
      marginTop: '0.9em',
      maxWidth: '90%',
      padding: '0.12em 0',
      ...props.style,
    }}
  >
    {children}
  </Label>
);

export const ExpandGeneralStats = styled(motion.div)`
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: ${({ expanded }) => (expanded ? '1.2em 5em' : '0')};

  @media screen and (max-width: 500px) {
    padding: ${({ expanded }) => (expanded ? '1.2em 1em' : '0')};
  }

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    /* IE10+ specific styles go here */
    ${({ expanded }) => (expanded
  ? css`
            overflow: auto !important;
            min-height: 600px;
          `
  : '')}
  }
`;

export const StatisticsPage = styled(Page)`
  max-width: 860px;
  align-self: center;
  padding-left: 1em;
  padding-right: 1em;
  overflow: visible;
  @media screen and (min-width: 750px) {
    max-width: 960px;
    [name="tile"] {
      flex-basis: 25%;
    }
  }

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    /* IE10+ specific styles go here */
    width: 860px;
  }
`;

export const ActionButton = styled.button`
  border: 1px solid
    ${getBrandingColor(colorTypes.statisticsToggleExpandGeneralStatsBorder)};
  background: white;
  border-radius: 10px;
  color: ${getBrandingColor(colorTypes.statisticsToggleExpandGeneralStats)};
  font-size: 1em;
  padding: 0.8em;
  margin-top: 1.6em;
  transition: all 0.2s;

  :hover {
    cursor: pointer;
    background: #f3f3f3;
  }

  :active,
  :active:hover {
    background: #eaeaea;
  }

  :focus {
    outline: none;
  }

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    /* IE10+ specific styles go here */
    min-height: 3em;
  }
`;

export const FilterRow = styled(Row)`
  border-bottom: 1px solid ${getBrandingColor(colorTypes.cellBorder)};
`;

export const ChartContainer = styled.div`
    position: relative;
    left: -100px;
    width: 1211.2px;
`;

export const SwtichWrapper = styled.div`
                    width: fit-content;
                    margin-bottom: 1.5em;
`;

export const ChartWrapper = styled.div`
`;
